export default (theme) => ({
  topbar: {
    position: 'fixed',
    width: '100%',
    top: 0,
    left: 0,
    right: 'auto',

    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  topbarShift: {
    marginLeft: '271px',
    width: 'calc(-271px + 100vw)',
  },
  drawerPaper: {
    zIndex: 1200,
    overflowX: 'hidden',
    width: '271px',
    border: 'none',
  },
  sidebar: {
    width: '270px',
  },
  content: {
    marginTop: '64px',
    backgroundColor: theme.palette.background.default,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    height: 'calc(100% - 64px)',
    display: 'flex',
    flexDirection: 'column',
  },
  contentShift: {
    marginLeft: '270px',
  },
})
